export const isVisibleOwnerPropertyItem = item => item?.successYn !== false;

const normalizeQuerySeqs = querySeqs => {
  if (!Array.isArray(querySeqs)) return [];

  return [
    ...new Set(
      querySeqs
        .filter(querySeq => querySeq != null && querySeq !== "")
        .map(Number)
        .filter(Number.isFinite),
    ),
  ];
};

export const getMultiSearchBatchTracking = response => {
  const batchResult = response?.result || response;
  const results = Array.isArray(batchResult?.results) ? batchResult.results : [];
  const querySeqs = normalizeQuerySeqs(
    results.map(item => item?.owner_property_query_seq ?? item?.ownerPropertyQuerySeq),
  );

  return {
    querySeqs,
    hasInitialFailure:
      Number(batchResult?.failCount) > 0 || results.some(item => item?.success === false),
  };
};

export const getMultiSearchBatchStatus = (items, querySeqs) => {
  const normalizedQuerySeqs = normalizeQuerySeqs(querySeqs);
  if (normalizedQuerySeqs.length === 0) {
    return { hasFailure: false, isSettled: false };
  }

  const itemByQuerySeq = new Map(
    (Array.isArray(items) ? items : [])
      .filter(item => Number.isFinite(Number(item?.ownerPropertyQuerySeq)))
      .map(item => [Number(item.ownerPropertyQuerySeq), item]),
  );
  const trackedItems = normalizedQuerySeqs.map(querySeq => itemByQuerySeq.get(querySeq));

  return {
    hasFailure: trackedItems.some(item => item?.progressYn === false && item?.successYn === false),
    isSettled: trackedItems.every(item => item != null && item.progressYn === false),
  };
};
